import { services, solutionCards } from "./site-data";

export type LandingPageData = {
  slug: string;
  path: string;
  pageTitle: string;
  metadataTitle: string;
  description: string;
  keywords: string[];
  image: string;
  eyebrow: string;
  summary: string;
  sectionTitle: string;
  items: Array<{ title: string; text: string }>;
  audienceTitle: string;
  audience: string[];
  acceptanceTitle?: string;
  acceptance?: Array<{ title: string; text: string }>;
};

const servicePageConfig = [
  {
    slug: "brand-positioning",
    pageTitle: "企业品牌定位与产品价值表达服务",
    metadataTitle: "品牌定位与产品表达服务",
    description:
      "梳理目标客户、品牌定位、价值主张和产品卖点，帮助制造、科技与专业服务企业建立清晰一致、经得起客户比较的市场表达。",
    keywords: [
      "企业品牌定位",
      "品牌定位策划",
      "产品价值主张",
      "产品卖点提炼",
      "品牌表达体系",
      "B2B品牌策划",
      "制造业品牌升级",
    ],
    image: "/assets/city.jpg",
    detailDescriptions: [
      "结合市场环境、竞争格局与业务目标，明确品牌应该服务的人群、解决的问题和差异化位置。",
      "梳理客户角色、采购关注点与决策障碍，让品牌表达建立在真实需求和比较标准之上。",
      "把功能、工艺、服务与交付能力转化为客户能够理解和验证的产品价值与应用场景。",
      "统一官网、内容、销售资料与传播渠道中的核心语言，减少不同团队之间的表达偏差。",
    ],
    audience: [
      "产品能力较强，但品牌价值和差异化难以被客户快速理解的企业",
      "准备升级官网、产品内容或销售资料，需要先统一价值表达的团队",
      "进入新市场或推出新产品，需要重新梳理目标客户与品牌定位的企业",
    ],
  },
  {
    slug: "website-development",
    pageTitle: "企业官网与海外独立站建设服务",
    metadataTitle: "企业官网与海外独立站建设",
    description:
      "从客户决策路径出发，提供企业官网、外贸独立站和多语言网站的策略、设计、开发、CMS、数据监测与询盘承接建设。",
    keywords: [
      "企业官网建设",
      "企业网站设计",
      "海外独立站建设",
      "外贸独立站建设",
      "多语言网站建设",
      "B2B网站建设",
      "官网改版",
      "网站询盘优化",
    ],
    image: "/assets/laptop.jpg",
    detailDescriptions: [
      "围绕客户浏览、理解、比较和咨询的任务规划页面层级、导航结构与核心转化路径。",
      "通过产品信息、行业场景、案例与企业实力建立专业感和信任，降低客户判断成本。",
      "完成响应式前端与内容管理能力建设，使企业能够持续维护产品、案例和洞察内容。",
      "配置访问分析、来源记录、询盘表单和联系入口，为后续搜索与转化优化提供数据基础。",
    ],
    audience: [
      "现有官网信息陈旧、结构混乱或无法有效承接业务咨询的企业",
      "准备开拓海外市场，需要建设外贸独立站或多语言官网的制造与出口企业",
      "希望网站能够长期运营，并连接内容、搜索和线索管理的团队",
    ],
  },
  {
    slug: "content-marketing",
    pageTitle: "企业内容营销与内容增长服务",
    metadataTitle: "企业内容营销与内容增长",
    description:
      "围绕产品、应用场景、客户问题和行业经验规划内容主题，持续建设可检索、可传播并支持销售转化的企业内容资产。",
    keywords: [
      "企业内容营销",
      "内容增长服务",
      "B2B内容营销",
      "SEO内容策划",
      "行业内容运营",
      "产品内容策划",
      "企业内容体系",
      "内容资产运营",
    ],
    image: "/assets/team.jpg",
    detailDescriptions: [
      "根据业务目标、客户搜索需求与销售问题建立主题地图，明确内容优先级和持续发布节奏。",
      "把产品能力、应用场景、采购问题与客户实践转化为易理解、可比较的页面和文章内容。",
      "规划行业洞察、选型指南与问题解答，覆盖客户从认知到决策的不同信息需求。",
      "连接官网、搜索和传播渠道，让内容持续获得访问、支持销售沟通并沉淀为长期资产。",
    ],
    audience: [
      "具备行业经验，但缺少稳定内容规划与发布机制的企业",
      "希望通过自然搜索和专业内容获得长期客户关注的 B2B 团队",
      "产品复杂、销售周期较长，需要内容辅助客户理解和决策的企业",
    ],
  },
  {
    slug: "seo-geo",
    pageTitle: "SEO、GEO 与 AI 搜索优化服务",
    metadataTitle: "SEO、GEO与AI搜索优化服务",
    description:
      "通过关键词研究、技术 SEO、内容主题、结构化数据与 GEO 优化，提升企业在 Google、百度及 AI 搜索回答中的品牌可见性。",
    keywords: [
      "SEO优化服务",
      "GEO优化服务",
      "AI搜索优化",
      "生成式引擎优化",
      "Google SEO",
      "百度SEO",
      "技术SEO",
      "AI搜索可见性",
    ],
    image: "/assets/SEO与GEO优化图.png",
    detailDescriptions: [
      "分析目标客户的搜索问题、关键词难度与页面意图，形成核心词、场景词和长尾词的页面映射。",
      "检查抓取、索引、站点结构、页面性能、规范链接与结构化数据，修复影响收录的技术问题。",
      "围绕主题建立服务页、解决方案页、案例与专业文章，让页面内容真正覆盖客户决策需求。",
      "增强品牌实体、事实信息、引用来源和内容结构，使企业更容易进入生成式搜索与 AI 回答。",
    ],
    audience: [
      "网站已上线，但自然搜索曝光、有效收录或目标关键词排名不足的企业",
      "希望同时布局传统搜索与 AI 搜索可见性的品牌和专业服务机构",
      "面向海外市场，需要建立 Google SEO、英文内容和产品搜索基础的企业",
    ],
  },
  {
    slug: "market-growth",
    pageTitle: "企业市场增长与数字营销服务",
    metadataTitle: "企业市场增长与数字营销",
    description:
      "从目标市场、客户需求和竞争格局出发，制定品牌传播、内容、搜索与渠道协同的增长策略，并通过数据持续复盘优先级。",
    keywords: [
      "企业市场增长",
      "数字营销服务",
      "增长策略咨询",
      "市场增长策略",
      "B2B数字营销",
      "海外市场营销",
      "竞品分析",
      "客户需求分析",
    ],
    image: "/assets/earth.jpg",
    detailDescriptions: [
      "研究市场规模、客户结构、竞争品牌与渠道变化，识别影响增长的机会和限制条件。",
      "明确阶段目标、重点客户、核心信息与资源边界，将增长任务转化为可执行优先级。",
      "协调官网、内容、搜索、社交与销售触点，避免渠道动作彼此分散或重复投入。",
      "建立关键指标、来源记录和阶段复盘机制，根据真实反馈调整市场动作与资源配置。",
    ],
    audience: [
      "市场动作较多但缺少统一目标、优先级和数据反馈的企业",
      "进入新行业或新区域，需要判断客户、竞品与渠道机会的团队",
      "希望连接品牌、内容、搜索与销售协作的 B2B 企业",
    ],
  },
  {
    slug: "lead-operations",
    pageTitle: "企业线索承接与持续增长运营服务",
    metadataTitle: "企业线索承接与增长运营",
    description:
      "完善询盘表单、邮件、即时通讯、来源追踪和运营复盘，让网站访问与营销动作形成可识别、可跟进、可持续优化的客户线索。",
    keywords: [
      "企业线索运营",
      "网站询盘优化",
      "线索承接",
      "获客运营",
      "网站持续运营",
      "询盘来源追踪",
      "转化路径优化",
      "B2B线索管理",
    ],
    image: "/assets/office.jpg",
    detailDescriptions: [
      "统一表单、电话、邮件和即时通讯入口，让不同访问场景都有明确、低阻力的联系动作。",
      "记录渠道、页面、内容与活动来源，帮助团队判断哪些动作带来有效访问和客户线索。",
      "按业务重点持续更新内容、产品页面和转化入口，保持网站与市场变化同步。",
      "结合访问、询盘和一线销售反馈进行周期复盘，确定下一阶段的页面与运营优化事项。",
    ],
    audience: [
      "网站已有访问，但咨询入口分散、线索来源不清或跟进容易遗漏的企业",
      "需要持续维护官网内容、搜索表现与转化路径的团队",
      "希望用数据连接市场动作、网站访问和销售反馈的 B2B 企业",
    ],
  },
];

const solutionPageConfig = [
  {
    slug: "domestic-brand-growth",
    pageTitle: "国内企业品牌增长解决方案",
    metadataTitle: "国内企业品牌增长方案",
    description:
      "面向国内市场梳理品牌定位、官网阵地、内容体系、SEO/GEO 与咨询入口，帮助企业建立持续积累的品牌认知和自主获客基础。",
    keywords: [
      "国内品牌增长",
      "企业品牌增长方案",
      "品牌升级",
      "企业官网增长",
      "内容增长",
      "SEO优化",
      "GEO优化",
    ],
    audience: [
      "产品具备竞争力，但品牌认知和市场表达仍然薄弱的企业",
      "依赖销售或投放获客，希望建设官网、内容与搜索自主渠道的团队",
      "准备进行品牌升级、官网改版或内容体系建设的企业",
    ],
    acceptance: [
      {
        title: "统一表达",
        text: "形成一套经企业确认的品牌与产品口径，可用于官网、内容和销售资料。",
      },
      {
        title: "增长基础",
        text: "按项目范围验收核心页面、CMS、内容、搜索配置、咨询入口和数据记录。",
      },
      {
        title: "结果边界",
        text: "以交付物、发布记录和复盘动作为验收依据，不承诺搜索排名、流量、询盘或成交金额。",
      },
    ],
  },
  {
    slug: "product-global-expansion",
    pageTitle: "企业产品出海与海外获客解决方案",
    metadataTitle: "产品出海与海外获客方案",
    description:
      "围绕目标国家、海外客户和竞争环境，建设国际化品牌表达、多语言独立站、Google SEO/GEO 内容与可追踪的海外询盘路径。",
    keywords: [
      "产品出海",
      "企业出海方案",
      "海外获客",
      "Google SEO",
      "海外GEO优化",
      "多语言独立站",
      "海外询盘",
    ],
    audience: [
      "计划首次系统开拓海外市场，需要明确数字增长起点的企业",
      "已有出口业务，但海外品牌、独立站和自然搜索基础薄弱的制造企业",
      "希望提高海外客户理解、信任与询盘转化效率的外贸团队",
    ],
    acceptance: [
      {
        title: "市场与表达",
        text: "明确首期目标市场、产品优先级、客户角色和海外产品表达，避免无边界铺设。",
      },
      {
        title: "站点与询盘",
        text: "按合同验收独立站、多语言内容、搜索基础、联系入口和来源记录。",
      },
      {
        title: "双方责任",
        text: "企业负责产品、资质、价格和履约真实性并及时跟进线索；订单与回款不作绝对承诺。",
      },
    ],
  },
  {
    slug: "corporate-website-growth",
    pageTitle: "企业官网增长解决方案",
    metadataTitle: "企业官网增长与改版方案",
    description:
      "以业务目标和客户决策路径重构企业官网，通过信息架构、产品表达、内容系统、SEO 基础和数据监测提升理解、信任与咨询效率。",
    keywords: [
      "企业官网增长",
      "企业官网改版",
      "网站信息架构",
      "官网内容规划",
      "网站SEO",
      "官网询盘优化",
      "企业网站升级",
    ],
    audience: [
      "官网无法清晰说明产品价值、业务优势和应用场景的企业",
      "网站结构陈旧、内容难维护或客户咨询路径不清晰的团队",
      "希望官网同时承担品牌、内容、搜索和线索承接任务的企业",
    ],
    acceptance: [
      {
        title: "页面验收",
        text: "依据项目清单检查页面数量、信息结构、内容确认、响应式适配和主要浏览路径。",
      },
      {
        title: "运营验收",
        text: "检查 CMS 是否可维护，表单与联系入口是否可用，访问和来源数据是否正常记录。",
      },
      {
        title: "上线之后",
        text: "网站上线是增长基础，不等于自然产生客户；内容更新、搜索优化和销售跟进需持续进行。",
      },
    ],
  },
  {
    slug: "global-website-growth",
    pageTitle: "海外独立站增长解决方案",
    metadataTitle: "海外独立站增长方案",
    description:
      "面向海外目标市场建设品牌、产品、信任证明、多语言内容、Google SEO/GEO 与询盘入口完整连接的外贸独立站增长体系。",
    keywords: [
      "海外独立站",
      "外贸独立站建设",
      "独立站增长",
      "多语言网站",
      "海外SEO",
      "Google SEO",
      "海外询盘增长",
    ],
    audience: [
      "依赖第三方平台，希望建立企业自主海外品牌和客户渠道的团队",
      "已有独立站但产品内容、信任证明或询盘路径不完整的出口企业",
      "需要针对不同国家与语言持续扩展内容和搜索覆盖的企业",
    ],
    acceptance: [
      {
        title: "首期范围",
        text: "在启动时确认目标国家、语言、产品和页面范围，新增市场与站点单独评估。",
      },
      {
        title: "可用性验收",
        text: "检查多语言页面、移动端、搜索技术项、结构化数据和各类询盘入口。",
      },
      {
        title: "外部变量",
        text: "Google 收录、AI 引用、询盘数量和成交时间受市场与平台影响，不作固定结果承诺。",
      },
    ],
  },
  {
    slug: "manufacturing-growth",
    pageTitle: "制造企业品牌与出海增长解决方案",
    metadataTitle: "制造企业品牌与出海增长",
    description:
      "将制造企业的产品、工艺、供应链、应用场景与交付能力转化为官网、内容、搜索和询盘资产，支持国内品牌增长与海外市场拓展。",
    keywords: [
      "制造业品牌增长",
      "制造企业出海",
      "工厂海外获客",
      "制造业官网建设",
      "工业品内容营销",
      "制造业SEO",
      "外贸询盘",
    ],
    audience: [
      "具备产品、工艺与供应链优势，但线上表达不够专业的制造企业",
      "希望通过官网、内容和搜索持续获得国内外客户关注的工厂",
      "产品规格和应用复杂，需要建立行业内容与选型路径的工业企业",
    ],
    acceptance: [
      {
        title: "产品资料",
        text: "验收产品分类、关键参数、应用场景、工艺能力和企业确认的信任资料。",
      },
      {
        title: "客户路径",
        text: "检查客户能否完成查找、比较、选型、获取资料和发起咨询等关键任务。",
      },
      {
        title: "企业配合",
        text: "产品数据、认证、宣传口径、库存与履约信息由企业确认；缺少真实资料时不虚构补齐。",
      },
    ],
  },
];

export const serviceLandingPages: LandingPageData[] = servicePageConfig.map(
  (config) => {
    const service = services.find((item) => item.slug === config.slug)!;

    return {
      slug: config.slug,
      path: `/services/${config.slug}`,
      pageTitle: config.pageTitle,
      metadataTitle: config.metadataTitle,
      description: config.description,
      keywords: config.keywords,
      image: config.image,
      eyebrow: "Growth service",
      summary: service.description,
      sectionTitle: `${service.title}包含哪些内容`,
      items: service.items.map((title, index) => ({
        title,
        text: config.detailDescriptions[index],
      })),
      audienceTitle: "适合哪些企业",
      audience: config.audience,
    };
  },
);

export const solutionLandingPages: LandingPageData[] = solutionPageConfig.map(
  (config) => {
    const solution = solutionCards.find((item) => item.slug === config.slug)!;

    return {
      slug: config.slug,
      path: `/solutions/${config.slug}`,
      pageTitle: config.pageTitle,
      metadataTitle: config.metadataTitle,
      description: config.description,
      keywords: config.keywords,
      image: solution.image,
      eyebrow: "Growth solution",
      summary: solution.description,
      sectionTitle: `${solution.title}的核心路径`,
      items: solution.tags.map((title, index) => ({
        title,
        text: solution.details[index],
      })),
      audienceTitle: "适合哪些业务场景",
      audience: config.audience,
      acceptanceTitle: "如何验收，以及哪些结果不承诺",
      acceptance: config.acceptance,
    };
  },
);
